export const auth_routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("../Main.vue")
  },
  {
    path: "/cadastro",
    name: "Cadastro",
    component: () => import("../Signup.vue")
  },
  {
    path: "/recover-pass/:token",
    props: true,
    name: "Recuperação de Senha",
    component: () => import("../ForgotPasswordFire.vue")
  },
  {
    path: "/activate-account/:id",
    props: true,
    name: "Ative sua conta",
    component: () => import("../ActivateAccount.vue")
  },
  {
    path: "/auth/:id",
    props: true,
    name: "Ext Login",
    component: () => import("../AuthRevolution.vue")
  }
];

export default {};
